// extracted by mini-css-extract-plugin
export default {"offer":"offer___Amt0AkR","subheader":"subheader___Amt0AkR","content":"content___Amt0AkR","htmlWrapper":"htmlWrapper___Amt0AkR"};